<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-13-01"></menubar>
    </div>

    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">
          {{$t("title.system.meetingRoom.crreate")}}
        </label>
        <narrow-down @click="editOutlookMeetingRoom"
        v-show="this.$IsShowButFun('130103', meetingRoomInfo.deleteFlag, true) "
         slot="create">
          {{ $t("button.common.data.edit") }}
        </narrow-down>
        <sp-smart-button @click="OutlookMeetingRoomDelete"
        v-show="this.$IsShowButFun('130104', meetingRoomInfo.deleteFlag, true) "
         slot="cancel">
          {{ $t("button.common.data.delete") }}
        </sp-smart-button>
      </head-title>
    </el-row>

    <!--  body start  -->
    <div slot="body">
      <!-- subtitle -->
      <div class="main-title">
        {{ $t("label.system.meetingRoom.detail.meetingRoomDetail") }}
      </div>
      <!--  form start  -->
      <el-form
        :model="meetingRoomInfo"
        ref="ruleForm"
        label-width="272px"
        label-position="left"
        >

        <!--  会議室所属情報 start  -->
        <div class="info-area">
          <div class="info-title">
            {{ $t("label.system.meetingRoom.detail.detailList") }}
          </div>
          <div class="info-items">
            <!-- 施設名 -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.system.meetingRoom.detail.meetingRoomName') }}
              </div>
              <div class="info-item-content text-word-break">
                <div>
                  {{ meetingRoomInfo.meetingRoomName }}
                </div>
                <div class="font1">
                  {{ meetingRoomInfo.friganaName }}
                </div>
              </div>
            </div>
            <!-- オーナー名・ID -->
            <div class="info-row">
              <div class="info-item-label">
                オーナー名・ID
              </div>
              <div class="info-item-content text-word-break">
                <div>
                  {{ meetingRoomInfo.detailList.ownerName }}
                </div>
                <div class="font1">
                  {{ meetingRoomInfo.detailList.ownerExId }}
                </div>
              </div>
            </div>
            <!-- ビル名・ID -->
            <div class="info-row">
              <div class="info-item-label">
                ビル名・ID
              </div>
              <div class="info-item-content text-word-break">
                <div>
                  {{ meetingRoomInfo.detailList.buildingName }}
                </div>
                <div class="font1">
                  {{ meetingRoomInfo.detailList.buildingExId }}
                </div>
              </div>
            </div>
            <!-- フロア -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.system.meetingRoom.detail.floorName') }}
              </div>
              <div class="info-item-content text-word-break">
                {{ meetingRoomInfo.detailList.floorName }}
              </div>
            </div>
            <!-- エリア名 -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.system.meetingRoom.detail.areaName') }}
              </div>
              <div class="info-item-content text-word-break">
                {{ meetingRoomInfo.detailList.areaName }}
              </div>
            </div>
            <!-- リソース連携 -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.system.meetingRoom.detail.outlookLinkName') }}
              </div>
              <div class="info-item-content text-word-break">
                {{ meetingRoomInfo.detailList.resourceName }}
              </div>
            </div>
          </div>
        </div>
        <!--  会議室所属情報 end  -->

        <hr class="delimiter" />

        <!--  会議室予約情報 start  -->
        <div class="info-area">
          <div class="info-title">
            {{ $t("label.system.meetingRoom.detail.reserveDetailList") }}
          </div>
          <div class="info-items">
            <!--  RFID識別番号 -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.system.meetingRoom.create.rfidNumber') }}
              </div>
              <div class="info-item-content text-word-break">
                <div v-show="meetingRoomInfo.rfidNumber !== null && meetingRoomInfo.rfidNumber !== ''">
                  ・{{ meetingRoomInfo.rfidNumber }}
                </div>
              </div>
            </div>
            <!-- 利用可能人数 -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.system.meetingRoom.detail.capacity1') }}
              </div>
              <div class="info-item-content text-word-break">
                <div v-if="meetingRoomInfo.capacity != 21">
                  {{ meetingRoomInfo.capacity }}{{ $t("label.system.meetingRoom.detail.capacitySuffix") }}
                </div>
                <div v-if="meetingRoomInfo.capacity >= 21">
                  21名以上
                </div>
              </div>
            </div>


            <!-- 自動キャンセル -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.system.meetingRoom.detail.cancel') }}
              </div>
              <div class="info-item-content text-word-break">
                <div v-if="meetingRoomInfo.autoCancelEnableFlag">
                  {{ $t('label.system.meetingRoom.detail.cancelOn') }}
                </div>
                <div v-else>
                  {{ $t('label.system.meetingRoom.detail.cancelOff') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  会議室予約情報  end  -->

        <hr class="delimiter" />

        <!--  会議室詳細情報 start  -->
        <div class="info-area">
          <div class="info-title">
            {{ $t("label.system.meetingRoom.detail.mrDetailList") }}
          </div>
          <div class="info-items">
            <!--  メモ  -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.tag.meetingEdit.memo') }}
              </div>
              <div class="info-item-content text-word-break" style="white-space: pre-line;">
                {{ meetingRoomInfo.fixtures }}
              </div>
            </div>
            <!-- 施設の説明 -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.tag.meetingEdit.instructions') }}
              </div>
              <div class="info-item-content text-word-break" style="white-space: pre-line;">
                {{ meetingRoomInfo.description }}
              </div>
            </div>
            <!-- 用途で探す -->
            <div v-for="item in meetingRoomInfo.meetingTagGroupList" :key="item.meetingTagGroupId" class="info-row">
              <div class="info-item-label">
                {{ item.meetingTagGroupName }}
              </div>
              <div class="info-item-content text-word-break">
                <div class="tag-label-area">
                  <div class="tag-label"
                    v-for="item1 in item.meetingTagList"
                    :key="item1.meetingTagId"
                    :value="item1.meetingTagId">
                    {{item1.meetingTagName}}
                  </div>
                </div>
              </div>
            </div>
            <!-- PC画像 -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.meeting.reservation.confirm.image') }}
              </div>
              <div class="info-item-content text-word-break">
                <el-radio-group v-model="selectImgUrl">
                  <div class="info-item-img-area">
                    <el-radio class="info-item-img-radio" v-for="(item, index) in meetingRoomInfo.img" :key="index"
                      :label="item.url" disabled>
                      <so-smart-user-image class="info-item-img" :src="item.url"/>
                    </el-radio>
                  </div>
                </el-radio-group>
              </div>
            </div>
            <!-- SP画像 -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.meeting.reservation.confirm.imageSP') }}
              </div>
              <div class="info-item-content text-word-break">
                <el-radio-group v-model="selectImgSPUrl">
                  <div class="info-item-img-area">
                    <el-radio class="info-item-img-radio" v-for="(item, index) in meetingRoomInfo.imgSP" :key="index"
                      :label="item.url" disabled>
                      <so-smart-user-image class="info-item-img" :src="item.url"/>
                    </el-radio>
                  </div>
                </el-radio-group>
              </div>
            </div>
            <!-- 施設詳細
                 ダイレクトリンク -->
            <div class="info-row">
              <div class="info-item-label" style="white-space: pre-line;">
                {{ $t('label.tag.meetingEdit.roomDetailLink') }}
              </div>
              <div class="info-item-content text-word-break content-display-style" >
                <div>
                  {{ roomDetailUrl + meetingRoomInfo.meetingRoomId }}
                </div>
                <div>
                  <sp-smart-button
                    @click="copyRoomDetailLink"
                    class="copy-btn-button">
                      {{ $t("button.common.data.copy") }}
                  </sp-smart-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  会議室詳細情報 end  -->
      <hr class="delimiter" />
        <!-- スマートロック -->
        <!-- <el-row class="title-font">
          <el-col class="el-col-3">
            <span class="font-size-20">
              {{ $t("label.system.meetingRoom.edit.smartName") }}
            </span>
            <sp-smart-button
              @click="selectSmartLock"
              v-show="this.$IsShowButFun('020106', meetingRoomInfo.deleteFlag, true) "
              class="btn-button">{{ $t("button.common.data.edit") }}
            </sp-smart-button>
          </el-col>
          <el-col style="width:980px;margin-left: 2%;">
              <smart-lock-detail-edit-result-beautify
                :result="meetingRoomInfo.ASDataList"
                :deleteFlag ="this.$IsShowButFun('020106', meetingRoomInfo.deleteFlag, true) "
                @on-delete="deleteSl"/>
            </el-col>
        </el-row> -->
      </el-form>
      <!--  form end  -->

      <smart-lock-popup
        :airconList="this.meetingRoomInfo.ASDataList"
        :floor_id="this.meetingRoomInfo.detailList.floorId"
        :buildingId="this.meetingRoomInfo.detailList.buildingId"
        :meetingRoomId="this.meetingRoomInfo.meetingRoomId"
        :visible.sync="showSLDialog"
        :includeDeleteDataFlag="false"
        @on-selected="relatedSl"
      >
      </smart-lock-popup>

      <resource-related-popup
        :roomId="meetingRoomInfo.meetingRoomId"
        :type="type"
        :resourceType="resourceType"
        :visible.sync="showResourceDialog"
      >
      </resource-related-popup>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleSlIsShow"
        :msgParam="msgParamSl"
        @on-isPassParam="isPassParamSl">
      </el-dialog-prompt>

      <loading-dialog :dialogVisible="showLoading" />

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="deleteMeetingRoomIsShow"
        :msgParam="deleteMeetingRoomMsgParam"
        @on-isPassParam="isPassDeleteMeetingRoom">
      </el-dialog-prompt>

      <tag-popup
        :visible.sync="showTagPopup"
        :buildId="meetingRoomInfo.detailList.buildingId"
        :tagKbnFlg="tagKbnFlg"
        @updata="detailOutlookMeetingRoom"
      />
    </div>
    <!--  body end  -->
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import headTitle from "@/components/common/head/head";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import SpSmartButton from "@/components/common/sp-smart-button";
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import Menubar from "@/components/leftmenu/DashBoard";
import elDialogPrompt from "@/components/common/el-dialog-prompt";
import errorCodeMsg from "@/utils/error-code-msg"
import TagPopup from "@/components/system/popup/TagPopup";
import ResourceRelatedPopup from "@/components/system/popup/ResourceRelatedPopup";
import SoSmartUserImage from "@/components/common/image/ImageCheck";
import Configuration from "@/config/index";
// import SmartLockDetailEditResultBeautify from "@/components/system/SmartLockDetailEditResultBeautify";
import SmartLockPopup from "@/components/system/popup/SmartLockPopup";

export default {
  name: "OutlookMeetingRoomDetail",
  components: {
    MainLayout: MainLayout,
    headTitle: headTitle,
    LoadingDialog: LoadingDialog,
    narrowDown: narrowDown,
    SpSmartButton: SpSmartButton,
    Menubar: Menubar,
    elDialogPrompt: elDialogPrompt,
    TagPopup: TagPopup,
    ResourceRelatedPopup: ResourceRelatedPopup,
    SoSmartUserImage: SoSmartUserImage,
    // SmartLockDetailEditResultBeautify: SmartLockDetailEditResultBeautify,
    SmartLockPopup: SmartLockPopup
  },
  data() {
    return {
      id: null,
      index: null,
      showLoading: false,
      msgParam: this.$t("message.common.validation.settingMessage",{
        field: this.$t("label.system.meetingRoom.detail.acName")
      }),
      msgParamSl: this.$t("message.common.validation.settingMessage",{
        field: this.$t("label.system.meetingRoom.edit.smartName")
      }),
      deleteMeetingRoomMsgParam: this.$t("message.common.validation.deleteMessage",{
        field: this.$t("label.system.meetingRoom.detail.meetingRoom")
      }),
      deleteMeetingRoomIsShow: false,
      meetingRoomInfo: {
        meetingRoomId: null,
        meetingRoomName: null,
        capacity: null,
        fixtures: null,
        autoCancelEnableFlag: false,
        rfidNumber: null,
        deleteFlag: false,
        //ph5 Lot1 新增字段
        friganaName: null,
        description:null,
        meetingTagGroupList: [
          {
            meetingTagGroupId:null,
            meetingTagGroupName:null,
            meetingTagList:[
              {
                meetingTagId:null,
                meetingTagName:null
              }
            ]
          }
        ],
        detailList:
        {
          ownerId: null,
          ownerExId: null,
          ownerName: null,
          buildingId: null,
          buildingExId: null,
          buildingName: null,
          floorId: null,
          floorName: null,
          areaId: null,
          areaName: null,
          resourceName: null,
        },

        imgSP: [
          {
            id: null,
            url: null,
            isMainPortrait: true
          }
        ],
        img: [{
          id: null,
          url: null,
          isMainPortrait: true
        }],
        meetingTagList: [],
        ASDataList: [],

        optionId:null,
        optionTitle:null,
        optionRemark:null,
        commonShowFlag:false,

      },
      selectImgUrl: '',
      selectImgSPUrl: '',
      activeName: "first",
      imgFile: null,
      showACDialog: false,
      slIdList: [],
      deviceIds:[],
      deviceIdsSl: [],
      tagKbnFlg: null,
      showTagPopup: false,
      meetingTagList: [],
      showSLDialog: false,
      centerDialogVisibleSlIsShow: false,
      slId: null,
      slIndex: null,
      showResourceDialog: false,
      type: null,
      resourceType: null,
      roomDetailUrl: Configuration['public.app.url'] + '/noticeRedirect.html?noticeType=0903&uuid=',

    };
  },
  methods: {

    checkMeetingTagRelatedFlag () {
      for (const index of this.meetingRoomInfo.meetingTagList) {
        if (index.relatedFlag) {
          return true
        }
      }
      return false
    },
    checkMeetingTagName () {
      for (const index of this.meetingRoomInfo.meetingTagList) {
        if (index.meetingTagName != null && index.meetingTagName != '') {
          return true
        }
      }
      return false
    },
    openTagPopup (val) {
      this.tagKbnFlg = val
      this.showTagPopup = true
    },
    //削除
    OutlookMeetingRoomDelete() {
      this.deleteMeetingRoomIsShow = true
    },
    //編集
    editOutlookMeetingRoom() {
      this.$router.push({
        name: "system-outlookMeetingRoom-edit",
        params: {
          meetingRoomId: this.meetingRoomInfo.meetingRoomId,
        },
      });
    },

    //outlook会議室情報
    detailOutlookMeetingRoom() {
      this.showLoading = true;
       SystemManageApi.OutlookMeetingRoomDetailPageInit(
         this.meetingRoomInfo.meetingRoomId
       )
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
        this.meetingTagList = []
        this.meetingRoomInfo.detailList.ownerId = data.body.roomDetail.ownerId,
        this.meetingRoomInfo.detailList.ownerExId = data.body.roomDetail.ownerExId,
        this.meetingRoomInfo.detailList.ownerName = data.body.roomDetail.ownerName,
        this.meetingRoomInfo.detailList.buildingId = data.body.roomDetail.buildingId,
        this.meetingRoomInfo.detailList.buildingExId = data.body.roomDetail.buildingExId,
        this.meetingRoomInfo.detailList.buildingName = data.body.roomDetail.buildingName,
        this.meetingRoomInfo.detailList.floorId = Number(data.body.roomDetail.floorId),
        this.meetingRoomInfo.detailList.floorName = data.body.roomDetail.floorName,
        this.meetingRoomInfo.detailList.areaId = data.body.roomDetail.areaId,
        this.meetingRoomInfo.detailList.areaName = data.body.roomDetail.areaName
        this.meetingRoomInfo.detailList.resourceName = data.body.roomDetail.resourceName

        this.meetingRoomInfo.autoCancelEnableFlag = data.body.roomDetail.autoCancelEnableFlag
        this.meetingRoomInfo.meetingRoomId = data.body.roomDetail.id;
        this.meetingRoomInfo.meetingRoomName = data.body.roomDetail.name;
        this.meetingRoomInfo.capacity = data.body.roomDetail.capacity;
        this.meetingRoomInfo.fixtures = data.body.roomDetail.equipment;

        this.meetingRoomInfo.rfidNumber = data.body.roomDetail.rfid;

        this.meetingRoomInfo.deleteFlag = data.body.roomDetail.deleteFlag;
        //ph5 Lot1
        this.meetingRoomInfo.friganaName = data.body.roomDetail.friganaName
        this.meetingRoomInfo.description = data.body.roomDetail.description;
        this.meetingRoomInfo.buildingName = data.body.roomDetail.buildingName;
        this.meetingRoomInfo.creditCardPaymentFunctionFlag = data.body.roomDetail.creditCardPaymentFunctionFlag;


        if( data.body.roomDetail.portrait != null || data.body.roomDetail.portrait != undefined  &&  data.body.roomDetail.portrait.length > 0) {
          this.meetingRoomInfo.img = []
          for (let item of data.body.roomDetail.portrait) {
            this.meetingRoomInfo.img.push({
              id: item.id,
              url: this.$GetImageUrl(item.url),
              isMainPortrait: item.isMainPortrait
            })
            if(item.isMainPortrait){
              this.selectImgUrl = this.$GetImageUrl(item.url)
            }
          }
        }

        if( data.body.roomDetail.spPortrait != null || data.body.roomDetail.spPortrait != undefined &&  data.body.roomDetail.spPortrait.length > 0) {
          this.meetingRoomInfo.imgSP = []
          for (let item of data.body.roomDetail.spPortrait) {
            this.meetingRoomInfo.imgSP.push({
              id: item.id,
              url: this.$GetImageUrl(item.url),
              isMainPortrait: item.isMainPortrait
            })
            if(item.isMainPortrait){
              this.selectImgSPUrl = this.$GetImageUrl(item.url)
            }
          }
        }

        if( data.body.relatedSlList != null || data.body.relatedSlList != undefined ) {
          if (data.body.relatedSlList.length !== 0) {
            for (let relatedAc of data.body.relatedSlList) {
              this.meetingRoomInfo.ASDataList.push({
                id: relatedAc.id,
                name: relatedAc.name,
              });
            }
          }
        }

        this.meetingRoomInfo.meetingTagGroupList = [];
        if(data.body.roomDetail.meetingTagGroupList != null && data.body.roomDetail.meetingTagGroupList != undefined && data.body.roomDetail.meetingTagGroupList.length > 0) {
          for (const index of data.body.roomDetail.meetingTagGroupList) {
            this.meetingRoomInfo.meetingTagGroupList.push({
              meetingTagGroupId: index.meetingTagGroupId,
              meetingTagGroupName: index.meetingTagGroupName,
              meetingTagList: index.meetingTagList
            })
          }
        }

        })
        .finally(() => {
        this.showLoading = false;
        });
    },

    //削除
    deleteSuccess: function (param) {
      this.$messageIotSuccess(this.$t("message.common.delete", {
        field: param,
      }));
    },
    //削除バータン
    deleteSl(id, index) {
      this.slId = id
      this.slIndex = index
      this.centerDialogVisibleSlIsShow = true
    },
    selectSmartLock () {
      this.showSLDialog = true;
    },
    relatedSl (selectedSecurityDevices) {
      this.meetingRoomInfo.ASDataList = [];
      this.slIdList = [];

      for (let securityDevice of selectedSecurityDevices) {
        this.meetingRoomInfo.ASDataList.push({
          id: securityDevice.slId,
          name: securityDevice.slName,
        });

        this.slIdList.push(securityDevice.deviceId);
      }
    },
    isPassParamSl(param){
      this.deviceIdsSl = []
      if(param){
        this.deviceIdsSl.push(this.slId)
        SystemManageApi.deleteMeetingRoomDeviceRelationSL({
          role_id:this.meetingRoomInfo.meetingRoomId,
          deviceIds:this.deviceIdsSl
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(() => {
          let slDatas = this.meetingRoomInfo.ASDataList;
          let slIds = this.slIdList;
          slDatas.splice(this.slIndex, 1);
          slIds.splice(this.slIndex, 1);
          this.deleteSuccess(
            this.$t("label.system.meetingRoom.edit.smartName")
          );
        })
        .finally(() => {});
      }
    },
    isPassDeleteMeetingRoom(param){
      if(param){
        SystemManageApi.OutlookMeetingRoomDelete(this.meetingRoomInfo.meetingRoomId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(() => {
          this.deleteSuccess(
            this.$t("message.common.validation.meetingRoomsMessage")
          );
          this.$router.push({
            name: "system-outlookMeetingRoom-search",
          });
        })
        .finally(() => {});
      }
    },


    selectGoogleBth () {
      this.type = "01";
      this.resourceType = "01";
      this.showResourceDialog = true;
    },
    selectOutlookBth () {
      this.type = "01";
      this.resourceType = "02";
      this.showResourceDialog = true;
    },
    formatHourMinute (hour) {
      if (hour === '' || hour === null || hour === undefined) {
        return null
      }

      let itemStr = null
      if (hour < 60) {
        if (hour == 0) {
          itemStr = "00時00分";
        } else {
          itemStr = `00時${hour.toString()}分`;
        }
      } else {
        const timeHour = hour / 60
        if (timeHour.toString().includes(".")) {
          const realHour = Math.floor(timeHour);
          if (realHour < 10) {
            itemStr = `0${realHour}時${(timeHour - realHour) * 60}分`
          } else {
            itemStr = `${realHour}時${(timeHour - realHour) * 60}分`
          }
        } else {
          itemStr = `${(timeHour < 10 ? "0" : "") + timeHour}時00分`
        }
      }
      return itemStr
    },
    copyRoomDetailLink(){
      let link =  this.roomDetailUrl + this.meetingRoomInfo.meetingRoomId

      navigator.clipboard
      .writeText(link)
      .then(() => {
        this.$messageIotSuccess(
          this.$t("message.common.validation.successCopyMessageToText")
        );
      })
      .catch(() => {
        this.$messageIotError(this.$t("message.common.error.errorCopyLink"));
      });
    },
    taxRateFormat(val){

      if (!val) {
        return '';
      }

      let num = Number(val) * 1000000;

      let value = num * 100 / 1000000;

      return value + '%';
    }
  },
  created() {
    this.$authCheck("020101")
    this.meetingRoomInfo.meetingRoomId = this.$route.params.meetingRoomId;
    this.meetingRoomInfo.ASDataList = []
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/outlookMeetingRooms/search",
        title: "label.router.outlookMeetingRoom",
      },
      {
        path: "",
        title: "label.router.meetingRoomDetail",
      },
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  },
  mounted() {
    this.detailOutlookMeetingRoom();
  },
};
</script>

<style scoped lang="scss">
.span-margin{
  margin-left: 160px;
}
.span-margin-label{
  margin-left: 135px;
}
.font-size-20{
  color: #525250;
  font-size: 20px;
}
.font-size-16{
  width: max-content;
  color: #525250;
  font-size: 16px;
}
.margin-top-60{
  margin-top: 60px
}

.title {
  width: 200px;
  text-align: left;
  margin-bottom: 17px;
  margin-left: -200px;
  font-size: 16px;
  color: #525250;
}

.image-size-sp {
  ::v-deep .auth-image {
    background-color: #F7F7F2;
    height: 210px !important;
    max-width: 550px !important;
  }
}

.image-size-pc {
  ::v-deep .auth-image {
    background-color: #F7F7F2;
    height: 210px !important;
    max-width: 550px !important;
  }
}
.el-col-display {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 255px;
}
.display {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 117px;
}
::v-deep .el-switch.is-disabled .el-switch__core {
  cursor: pointer !important;
}
::v-deep .el-form-item {
  margin-bottom: 0 !important;
}
::v-deep .el-form-item__label {
  color: #525250 !important;
  font-size: 16px;
  height: 77px;
  line-height: 26px;
  background-color: rgba(235, 235, 230, 1);
  padding-left: 16px;
  padding-top: 16px;
}
::v-deep .el-form-item--small.el-form-item {
  margin-bottom: 0px !important;
}
::v-deep .el-icon-arrow-up:before {
  color: #525250;
}
.margin-left-2 {
  margin-left: 24px !important;
}
.span {
  font-size: 16px;
  color: #525250;
}
.text_position {
  position: absolute;
  right: 45px;
}
::v-deep .zdyInput {
  .el-input__inner {
    height: 26px;
    border-radius: 0px !important;
    color: #b8b8b4;
    border: 2px solid;
    border-color: #b8b8b4;
    font-size: 12px;
  }
  .el-input__inner::placeholder {
    color: #b8b8b4;
  }
  /* 谷歌 */
  .el-input__inner::-webkit-input-placeholder {
    color: #b8b8b4;
  }
}
::v-deep .cancel-width {
  .my-button {
    width: 152px;
    height: 32px;
  }
}
::v-deep .el-form-item__content {
  min-height: 26px;
  line-height: 26px;
}
.image {
  font-size: 25px;
  color: #b8b8b4;
}
::v-deep .zdyselect .el-input__icon {
  line-height: 40px !important;
  color: #525250;
}
::v-deep .el-table tr {
  background-color: #f2f2ed;
}
::v-deep .el-table__row {
  height: 72px;
}
::v-deep .el-table--scrollable-y .el-table__body-wrapper {
  height: 150px !important;
}
::v-deep .el-icon-delete {
  color: #525250;
}
::v-deep .el-table th,
.el-table td {
  padding: 4px 0;
}
::v-deep
  .el-table
  el-table--fit
  el-table--scrollable-x
  el-table--enable-row-hover
  el-table--enable-row-transition {
  width: 997px !important;
}
::v-deep .el-table__header {
  width: 997px;
}
::v-deep .el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: hidden;
}
::v-deep .el-table th > .cell {
  padding-left: 0px;
}
::v-deep .el-table .cell {
  padding-left: 0px;
}
.text-hidden {
  display: block;
  max-width: 210px;
}
.span-tile {
  display: block;
  padding-left: 9px;
  font-size: 16px;
  color: #525250;
}

.el-col-3 {
  width: 143px;
}

.el-col-12 {
  width: 574px;
}

.el-col-8 {
  width: 383px;
}

.el-col-span {
  display: block;
  margin-bottom: 280px;
}
// No.140
.btn-button {
  width: 80px;
  height: 36px;
  // float: right;
  z-index: 999;
  margin-top: 16px;
}
.copy-btn-button {
  width: 80px;
  height: 36px;
  // float: right;
  z-index: 999;
}


.display-line-box {
  display: flex;
  align-items: flex-start;
}

.contain-size {
  contain: size;
}

/* No.129 */
.hr{
    height: 1px;
    width: 800px;
    background-color: #D1D1CD;
    margin-top: 40px;
    margin-bottom: 40px;
}
.hr2{
    height: 1px;
    width: 800px;
    background-color: #D1D1CD;
    margin-top: 40px;
    margin-bottom: 4px;
}

.title-font::v-deep {
  .color {
    font-size: 20px;
  }
}
.edit-add-text-button {
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 10px;
  color: #329CA6;
  cursor: pointer;
}
.edit-add-text-button:hover {
  opacity: 0.8;
}

.no-data {
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #B8B8B3;
}

hr.delimiter {
  margin-top: 64px !important;
  margin-bottom: 64px !important;
  background-color: #d1d1cd !important;
}

.title-font {
  ::v-deep .color {
    display: none;
  }
  ::v-deep .el-table {
    margin-top: 0px !important;
  }
}

.info-area {
  display: flex;
  align-items: flex-start;
}
.info-title {
  width: 191px;
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 20px;
  font-weight: 300;
  line-height: 30px;
  text-align: left;
  color: #525250;
}
.info-items {
  border-top: 1px solid #D4D4D4;
  // width: calc(100% - 191px);
  flex: 1;
}
.info-row {
  display: flex;
  border-bottom: 1px solid #D4D4D4;
}
.info-item-label {
  padding: 16px;
  width: 177px;
  background-color: #EBEBE6;
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  text-align: left;
  color: #525250;
}
.info-item-content {
  padding: 16px;
  width: calc(100% - 177px);
  background-color: #F7F7F2;
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  color: #525250;
}
.info-item-content .font1 {
  font-size: 14px;
  line-height: 21px;
}
.info-item-content .font2 {
  font-size: 12px;
}
.info-item-content .font-weight1 {
  font-weight: 600;
}
.margin-top-20 {
  margin-top: 20px;
}
.info-item-flex {
  display: flex;
  align-items: center;
}
.tag-label-area {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.tag-label {
  font-size: 12px;
  height: 26px;
  line-height: 26px;
  padding: 0px 12px 0px 12px;
  border-radius: 50px;
  background-color: #F2F2ED;
  box-shadow: 4px 4px 8px 0px rgba(230, 230, 216, 1), -4px -4px 5px 0px rgba(255, 255, 255, 1);
}
.info-item-img-area {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 21px;
}
.info-item-img {
  width: 291px;
  height: 175px;
}
.text-margin {
  margin-left: auto;
}
::v-deep.info-item-img-radio .el-radio__label {
  display: block;
  padding-left: 0;
}
::v-deep.info-item-img-radio .el-radio__input {
  position: absolute;
  top: 8px;
  left: 8px;
}
::v-deep.info-item-img-radio.el-radio {
  margin-right: 0;
}
.must-star-style{
  color: #E65245;
}
.common-item-style{
  width: 98px;
  height: 31px;
  padding: 5px 7px;
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 14px;
  font-weight: 300;
  padding: 5px 7px;
  background-color: #D8D8D8;
  margin-right: 8px;
}
.choice-label-area {
  display: flex;
  gap: 8px;
  flex-direction: column;
}
.choice-style{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 16px;
  font-weight: 300;
  color: #525250;
}
.content-display-style{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
